module.exports = "<holiday-page></holiday-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appSettings/holiday.html
// module id = 1768
// module chunks = 0